// ----------------------------------------------------------------------------

function setSelectedIndex(element: HTMLSelectElement, index: number | number[]): void {
    const indices = Array.isArray(index) ? index : [index];

    for (let i = 0; i < element.options.length; i++) {
        const elOption = element.options[i];
        const isSelected = indices.includes(i);

        elOption.selected = isSelected;

        if (isSelected) {
            elOption.setAttribute('selected', '');
        } else {
            elOption.removeAttribute('selected');
        }
    }
}

// ----------------------------------------------------------------------------

export default setSelectedIndex;
